import { render } from "./HomeworkEditView.vue?vue&type=template&id=4d3514d8"
import script from "./HomeworkEditView.vue?vue&type=script&lang=js"
export * from "./HomeworkEditView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__